// extracted by mini-css-extract-plugin
module.exports = {"feeText":"cc_feeText_1014780759","feeDisclaimer":"cc_feeDisclaimer_1014780759"};